/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
import React from 'react'
import { SimilarLocation } from '../@types/IChainBenchmark'
import { TableSpan } from '../ChainBenchmark.styles'

export const generateSimilarityContent = (
  similarLocations: SimilarLocation[],
) => similarLocations.map((location, index) => (
  [
    <TableSpan
      key={location.address}
      $bold
      $left
    >
      {index + 1}
    </TableSpan>,
    <TableSpan
      key={location.address}
      $bold
      $left
    >
      {location.address}
    </TableSpan>,
  ]
))
